// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"oi_a bhm_a bhm_x","FilterForm__vgroup":"oi_b bhm_sv"};